import { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import fr from "./fr";
import en from "./en";
import legalFr from "./legal.fr";
import legalEn from "./legal.en";

export const LANGS = ["fr", "en"];
export const SITE_URL = "https://sidly.space";

export const ROUTES = {
  home: { fr: "", en: "" },
  services: { fr: "services", en: "services" },
  about: { fr: "a-propos", en: "about" },
  contact: { fr: "contact", en: "contact" },
  terms: { fr: "cgu-cgv", en: "terms-and-conditions" },
  legal: { fr: "mentions-legales", en: "legal-notice" },
  privacy: { fr: "politique-de-confidentialite", en: "privacy-policy" },
};

export const pathFor = (key, lang) => {
  const slug = ROUTES[key][lang];
  return `/${lang}${slug ? `/${slug}` : ""}`;
};

export const pageKeyFromSlug = (slug, lang) => {
  const clean = (slug || "").replace(/^\/+|\/+$/g, "");
  return Object.keys(ROUTES).find((k) => ROUTES[k][lang] === clean) || null;
};

const DICT = { fr, en };
const LEGAL = { fr: legalFr, en: legalEn };

const LangContext = createContext(null);

export function LangProvider({ lang, children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const value = useMemo(() => {
    const rest = location.pathname.replace(new RegExp(`^/${lang}`), "");
    const pageKey = pageKeyFromSlug(rest, lang);
    const otherLang = lang === "fr" ? "en" : "fr";
    return {
      lang,
      otherLang,
      t: DICT[lang],
      legal: LEGAL[lang],
      pageKey,
      to: (key) => pathFor(key, lang),
      switchPath: pathFor(pageKey || "home", otherLang),
      switchLang: () => navigate(pathFor(pageKey || "home", otherLang) + location.hash),
    };
  }, [lang, location.pathname, location.hash, navigate]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
